<template>
	<div class="friend-item" :class="active ? 'active' : ''" @contextmenu.prevent="showRightMenu($event)">
		<div class="friend-avatar">
			<head-image :size="42" :name="friend.nickName" :url="friend.headImage" :online="friend.online">
			</head-image>
		</div>
		<div class="friend-info">
			<div class="friend-name" style="font-weight: 600;">{{ friend.nickName }}</div>
			<div class="friend-online" style="margin-top: 4px;">
				<!-- <i class="el-icon-monitor online" v-show="friend.onlineWeb" title="电脑设备在线">
					<span class="online-icon"></span>
				</i> -->
				<div v-if="true" style="color: #9E9E9E;font-size: 14px;display: flex;align-items: center;height: 14px;">
					<!-- <span>[</span> 
					<img src="@/assets/image/icon_online.svg" alt="" class="status-icon" />
					<span>在线]</span> -->
					<p style="height: 18px;line-height: 18px;">
						[<img src="@/assets/image/icon_online.svg" alt="" style="margin-right: 2px;position: relative;top: 1px;" >在线]
					</p>
				</div>
				<!-- <i class="el-icon-mobile-phone online" v-show="friend.onlineApp" title="移动设备在线">
					<span class="online-icon"></span>
				</i> -->
				<div v-else  style="color: #9E9E9E;font-size: 14px;display: flex;align-items: center;height: 14px;position: relative;top: 1px;">
					<p style="height: 18px;line-height: 18px;">
						[<img src="@/assets/image/icon_off line.svg" alt="" style="margin-right: 2px;" >离线]
					</p>
			
					
				</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<slot></slot>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from "../common/RightMenu.vue";

export default {
	name: "frinedItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {
			menuItems: [{
				key: 'CHAT',
				name: '发送消息',
				icon: 'el-icon-chat-dot-round'
			}, {
				key: 'DELETE',
				name: '删除好友',
				icon: 'el-icon-delete'
			}]
		}
	},
	methods: {
		showRightMenu(e) {
			if (this.menu) {
				this.$refs.rightMenu.open(e, this.menuItems);
			}
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.msgInfo);
		}
	},
	props: {
		active: {
			type: Boolean
		},
		friend: {
			type: Object
		},
		menu: {
			type: Boolean,
			default: true
		}
	}

}
</script>

<style scope lang="scss">
.friend-item {
	height: 50px;
	display: flex;
	position: relative;
	padding: 5px 10px;
	padding-left: 15px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background-color:#e0e0df;
	}

	.friend-avatar {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.friend-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;

		.friend-name {
			font-size: var(--im-font-size);
			white-space: nowrap;
			overflow: hidden;
		}

		.friend-online {
			.online {
				font-weight: bold;
				padding-right: 2px;
				font-size: 16px;
				position: relative;
			}

			.online-icon {
				position: absolute;
				right: 0;
				bottom: 0;
				width: 6px;
				height: 6px;
				background: limegreen;
				border-radius: 50%;
				border: 1px solid white;
			}
		}
	}
}
.status-icon {
  display: block;
  width: 12px !important;
  height: 12px !important;
  margin: 0 2px !important;
  align-self: center;
  margin-top: 1px;
}
</style>
